import { render, staticRenderFns } from "./WaitStep.vue?vue&type=template&id=0a16840a&"
import script from "./WaitStep.vue?vue&type=script&lang=ts&"
export * from "./WaitStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports